import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCustomer } from "@/lib/customer";

export const DeleteAccountDialog = () => {
  const navigate = useNavigate();
  const { logout } = useCustomer();
  const [open, setOpen] = useState(false);
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      await api.customerDeleteMe();
      toast.success("Account eliminato. Ti abbiamo inviato una email di conferma.");
      await logout();
      navigate("/concorsi", { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore durante l'eliminazione");
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setWord(""); }}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-red-400 hover:text-red-300 hover:bg-red-500/10 gap-2" data-testid="delete-account-button"><Trash2 className="h-4 w-4" /> Elimina account</Button>
      </DialogTrigger>
      <DialogContent className="bg-background border-border" data-testid="delete-account-dialog">
        <DialogHeader>
          <DialogTitle>Eliminare il tuo account?</DialogTitle>
          <DialogDescription>
            Verranno cancellati definitivamente i tuoi dati personali (email, nome, telefono, consensi). Le giocate saranno rese anonime; le ricevute dei premi non ancora ritirati restano valide: conserva il seriale o il PDF.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <p className="text-sm">Per confermare digita <span className="font-mono-code font-bold">ELIMINA</span></p>
          <Input data-testid="delete-account-confirm-input" value={word} onChange={(e) => setWord(e.target.value)} placeholder="ELIMINA" autoComplete="off" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="delete-account-cancel">Annulla</Button>
          <Button variant="destructive" disabled={word.trim() !== "ELIMINA" || busy} onClick={confirm} data-testid="delete-account-confirm">{busy ? "Eliminazione…" : "Elimina definitivamente"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
